/**
 * Join class names with a space
 * @param classNames - The class names to join
 * @returns The joined class names
 */
export const joinClassNames = (...classNames: (string | undefined | null)[]): string => {
    return classNames.filter(Boolean).join(' ');
};
